import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'
import scrollIntoView from 'scroll-into-view';
import { hide, show, toggle } from "slidetoggle";
import { Wave } from './snippets/wave';
import { slideToggleDefaults } from './modules/_settings';
import { register as registerSwiperElemets } from "swiper/element/bundle";
// import RevealHero from './sections/reveal-hero';
registerSwiperElemets(); //This registers Swiper's custom HTML elements
//Webpack was pulling the react swiper setup
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import FruitAnimation from './snippets/fruit';
import DragScroll from './snippets/drag-scroll';
import PopIn from './snippets/pop-in';
import FadeIn from './layout/fade-in';
gsap.registerPlugin(ScrollTrigger);
import Cookies from "js-cookie";

//Register custom elements
customElements.define("wave-element", Wave);

window.setSectionTabindex = (el, to = "-1") => {
  el.querySelectorAll('a, input, button').forEach((item) => {
    item.setAttribute("tabindex", to);
  });
};
window.slideToggle = (el, opts = {}) => {
  toggle(el, { ...slideToggleDefaults, ...opts });
};
window.slideUp = (el, opts = {}) => {
  hide(el, { ...slideToggleDefaults, ...opts });
};;
window.slideDown = (el, opts = {}) => {
  show(el, { ...slideToggleDefaults, ...opts });
};
window.scrollIntoView = scrollIntoView;
window.Theme = {
  cookies: Cookies,
  colors: COLORS,
  breakpoints: BREAKPOINTS,

  //Call this on any section to add helper classes
  initContext: (context = document) => {
    window.designMode = document.body.classList.contains("design-mode");

    context.querySelectorAll(".slide-toggle-next").forEach((slideTrigger) => {
      slideTrigger.addEventListener(
        "click",
        (e) => {
          window.slideToggle(slideTrigger.nextElementSibling);
        },
        true
      );
    });
    context.querySelectorAll(".slide-toggle-prev").forEach((slideTrigger) => {
      slideTrigger.addEventListener(
        "click",
        (e) => {
          window.slideToggle(slideTrigger.previousElementSibling);
        },
        true
      );
    });

    // Scroll to ID on page.
    context.querySelectorAll('a[href^="#"]:not([href="#"]').forEach((link) => {
      link.addEventListener(
        "click",
        (e) => {
          e.preventDefault();

          window.scrollTo({
            top: document.querySelector(link.getAttribute('href')).getBoundingClientRect().top - document.querySelector('#header').offsetHeight,
            behavior: 'smooth',
          })
        },
        true
      );
    });

    // Add target blank to external page links
    context.querySelectorAll('a').forEach((link) => {
      if (link.hostname !== window.location.hostname) {
        link.target = '_blank';
        link.rel = 'noreferrer noopener';
      }
    });

    //This delay offsets the reveal hero pinning
    setTimeout(() => {
      new FruitAnimation({
        section: context,
      });
      new DragScroll({
        section: context,
      });
      new PopIn({
        section: context,
      });
      new FadeIn({
        section: context,
      });
    }, 10);
  }
};
window.getRandomNumber = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
window.gsap = gsap;

//Add helper classes
document.addEventListener('DOMContentLoaded', () => {
  Theme.initContext();
});

Alpine.plugin(intersect);
window.Alpine = Alpine;
